/* eslint-disable no-unused-vars */
import React, {FormEvent, useEffect, useState} from 'react';
import {IonContent, IonPage} from '@ionic/react';
import {AxiosError} from 'axios';
import {Keyboard} from '@capacitor/keyboard';
import {Capacitor} from '@capacitor/core';
import {isValidEmail} from '../utilis/isValidEmail';
import {authService} from '../api/authService';
import useFetchToken from '../hooks/useFetchToken';
import UILogo from '../components/UICommon/UILogo';
import UIImage from '../components/UICommon/UIImage';
import UILoadingIndicator from '../components/UICommon/UILoadingIndicator';
import UIErrorIndicator from '../components/UICommon/UIErrorIndicator';
import LoginPageForm from '../components/LoginPage/LoginPageForm';
import {KeyboardResize} from '@capacitor/keyboard';

import img from '../assets/images/login.png';

const LoginPage: React.FC = () => {
  const [formValues, setFormValues] = useState({email: '', password: ''});
  const [formErrorMessages, setFormErrorMessages] = useState({email: '', password: ''});
  const [requestErrorMessage, setRequestErrorMessage] = useState('');
  const {isLoading, isError, error, mutate} = useFetchToken(formValues.email as string, formValues.password as string);
  const [isKeyboard, setKeyboard] = useState(0);
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    const userEmail = authService.getUserEmailFromLocalStorage();
    const userPass = authService.getUserPasswordFromLocalStorage();
    const tmpFormValues = {...formValues};
    if (userEmail) {
      tmpFormValues.email = userEmail;
    }

    if (userPass) {
      tmpFormValues.password = userPass;
    }

    setFormValues(tmpFormValues);
  }, []);

  useEffect(() => {
    if (!isError) return;
    if (error instanceof AxiosError) {
      error?.response?.data?.detail === 'No active account found with the given credentials' ?
      setRequestErrorMessage('Fel inloggningsuppgifter, försök igen.') :
      setRequestErrorMessage('Ett oväntat fel inträffade');
    }
  }, [isError]);

  if (Capacitor.isNativePlatform()) {
    Keyboard.setResizeMode({
      mode: KeyboardResize.None,
    });
    Keyboard.addListener('keyboardWillShow', (info) => {
      document?.activeElement?.scrollIntoView(true);
      setKeyboard(info.keyboardHeight);
      setIsKeyboardOpen(true);
    });

    Keyboard.addListener('keyboardWillHide', () => {
      setKeyboard(0);
      setIsKeyboardOpen(false);
    });
  }

  const onChange = (event: any) => {
    const {name, value} = event.target;
    setFormValues({...formValues, [name]: value});
  };

  const onKeyPress = (event: any) => {
    const key = event.key.toLowerCase();

    if (key === 'enter') {
      submit();
    }
  };

  const validate = () => {
    const errors = {email: '', password: ''};
    if (!formValues.email) {
      errors.email = 'Ange din e-postadress';
    } else if (!isValidEmail(formValues.email)) {
      errors.email = 'E-postadressen är ogiltig';
    }
    if (!formValues.password) {
      errors.password = 'Ange ditt lösenord';
    }
    setFormErrorMessages(errors);
    return errors.email.length == 0 && errors.password.length == 0;
  };

  const submit = (event?: FormEvent) => {
    event && event.preventDefault();
    if (validate()) {
      mutate();
    }
  };

  return (
    <IonPage>
      <IonContent>
        <div className={`flex h-full bg-black-midnight md:bg-gray-login`}>
          <div className='w-full md:w-1/2 flex flex-col justify-between px-8 pt-8 md:px-20 md:pt-20'>
            <div className='h-1/2 md:h-2/5 flex flex-col z-10'>
              <UILogo style='text-white md:text-navy-primary text-left text-2xl leading-6'/>
              <div className='mt-auto md:my-auto font-Outfit font-semibold text-white md:text-navy-secondary'>
                <h1 className='text-4xl md:text-6xl whitespace-nowrap'>Hej, tatuerare.</h1>
                <h2 className='text-2xl md:text-34'>Välkommen! 👋</h2>
              </div>
              {isError && <UIErrorIndicator message={requestErrorMessage}/>}
              {isLoading && <UILoadingIndicator style='text-white md:text-navy-black'/>}
            </div>
            <div className='flex-grow flex flex-col'>
              <LoginPageForm
                formValues={formValues}
                formErrorMessages={formErrorMessages}
                onChange={onChange}
                onKeyPress={onKeyPress}
                login={submit}
              />
              <div className='mt-auto text-gray-primary font-Manrope text-sm
               font-semibold text-center w-full hidden md:block'>
                @2022 SVERGIES REGISTRERADE TATUERARE
              </div>
            </div>
          </div>
          <div className='h-1/2 w-full absolute md:w-1/2 md:p-5 md:h-screen md:right-0 md:z-0'>
            <UIImage url={img} style='md:rounded-3xl'/>
          </div>
        </div>
        {isKeyboardOpen && <div style={{height: (isKeyboard - 120)}}
          className='bg-black-midnight md:bg-gray-login'></div>}
      </IonContent>
    </IonPage>
  );
};

export default LoginPage;
